import { Session } from '@/types/session.types';

const sortedSessionsByTimestamp = (sessions?: Session[], direction?: 'asc' | 'desc') => {
  if (!sessions) return [];

  if (direction === 'asc') {
    return sessions.toSorted((a, b) => {
      if (!a.timestamp || !b.timestamp) return 0;
      return a.timestamp < b.timestamp ? -1 : 1;
    });
  }

  return sessions.toSorted((a, b) => {
    if (!a.timestamp || !b.timestamp) return 0;
    return a.timestamp > b.timestamp ? -1 : 1;
  });
};

export default sortedSessionsByTimestamp;
